import { render, staticRenderFns } from "./code1.vue?vue&type=template&id=19542d14&scoped=true&"
import script from "./code1.vue?vue&type=script&lang=js&"
export * from "./code1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19542d14",
  null
  
)

export default component.exports